/** @prettier */

/**
 * 数値変換関連関数一覧
 */

/**
 * バイトをキロバイトに変換する（切り上げ）
 * @param byte バイト数
 * @param num 小数点num位まで残す
 * @returns キロバイト
 */
const convertByteIntoKiloByte = (byte: number, num: number = 0) => {
  return Math.ceil((byte / 1024) * Math.pow(10, num)) / Math.pow(10, num);
};

/**
 * バイトをメガバイトに変換する（切り上げ）
 * @param byte バイト数
 * @param num 小数点num位まで残す
 * @returns メガバイト
 */
const convertByteIntoMegaByte = (byte: number, num: number = 0) => {
  return (
    Math.ceil((byte / (1024 * 1024)) * Math.pow(10, num)) / Math.pow(10, num)
  );
};

/**
 * 四捨五入を行う
 * @param value 四捨五入する値
 * @param num 小数点num位まで残す
 * @returns 四捨五入した値
 */
const roundOff = (value: number, num: number = 0) => {
  return Math.round(value * Math.pow(10, num)) / Math.pow(10, num);
};

export {convertByteIntoKiloByte, convertByteIntoMegaByte, roundOff};
